import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import { transform as transformPhone } from '../InputPhone';
import { COULD_NOT_VERIFY_ADDRESS, PHONE_PRESENT_ON_EXISTING_ACCOUNT } from '../../constants';
import usePrequalCreate from '../../resources/prequal/usePrequalCreate';
import usePrefill from '../../resources/prefill';

const errorSchema = {
  [COULD_NOT_VERIFY_ADDRESS]: {
    street: ['The address provided could not be verified. It must be your personal residence. PO Boxes and commercial addresses are not permitted.'],
    city: [''],
    state: [''],
    zipCode: [''],
  },
  [PHONE_PRESENT_ON_EXISTING_ACCOUNT]: {},
};

const useForm = () => {
  const { data: prefill } = usePrefill();

  const onSubmit = (form) => ({
    ...form,
    phone: transformPhone(form.phone),
    ...prefill?.id && { prefillId: prefill.id },
  });

  const useMutation = () => usePrequalCreate({
    revalidate: false,
    populateCache: true,
    isReapply: true,
  });

  return useSWRMutationForm({
    useMutation,
    onSubmit,
    errorSchema,
    useUnhandledError: useErrorToSnackbar,
  });
};

export default useForm;
